import { CustomApiException } from '@/modules/core/app/models/CustomApiException';

export class AiExtractionAlreadyStartedException extends CustomApiException {
  constructor(model: Partial<AiExtractionAlreadyStartedException> = {}) {
    super(model);
  }
}
